module.exports = __webpack_public_path__ + "img/img-dingzhi-s1-tuya.3cc0cf9c.png";